<template>
  <div class="section">
    <div class="toolbar">
      <div class="section-title">商品明细</div>
      <el-input
        placeholder="商品明细"
        v-model="searchParams.keyword"
        style="width:200px"
        size="small"
        clearable
      ></el-input>
      <!-- <el-input
        ref="PartsSearchInput"
        v-model="searchParams.keyword"
        size="mini"
        clearable
        style="width:200px"
        @keyup.enter.native="partsEnter"
        @focus="focusPartsSearchInput"
        placeholder="0键/Alt+0定位、Enter查询"
      >
        <div slot="append" class="parts-search-append">
          <div @click="search" class="parts-search-icon">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </el-input> -->
      <span>业务单号</span>
      <el-input
        placeholder="业务单号"
        style="width:200px"
        v-model="searchParams.sourceBillNo"
        size="small"
        clearable
      ></el-input>
      <span>收付类型</span>
      <el-select v-model="searchParams.settleType" style="width:200px" placeholder="收付类型" size="small" clearable>
        <el-option label="全部" :value="0" />
        <el-option label="应收" :value="1" />
        <el-option label="应付" :value="2" />
      </el-select>
      <span>业务类型：</span>
      <el-select
        v-model="searchParams.sourceBillTypes"
        multiple
        collapse-tags
        style="width:200px"
        placeholder="全部"
        size="small"
        clearable
      >
        <el-option v-for="item in billtypeList" :label="item.name" :value="item.code" :key="item.code" />
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="search">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
      <!-- <el-button size="small" type="warning" icon="el-icon-download">导出</el-button> -->
    </div>
    <el-table :data="tableData" border stripe size="small" max-height="420" show-summary :summary-method="getSummaries">
      <el-table-column label="序号" width="60" type="index" fixed></el-table-column>
      <el-table-column prop="billDate" label="业务日期" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="billNo" label="业务单号" width="200" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="billType" label="业务类型" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="partNo" label="商品编码" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="partName" label="商品名称" width="200" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="price" label="单价" width="100" show-overflow-tooltip sortable>
        <template v-slot="scope">
          <span>￥{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qty" label="数量" width="80" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="amount" label="小计" width="110" show-overflow-tooltip sortable>
        <template v-slot="scope">
          <span>￥{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amountOut" label="应付" width="100" show-overflow-tooltip sortable>
        <template v-slot="scope">
          <span>￥{{ scope.row.amountOut }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amountIn" label="应收" width="100" show-overflow-tooltip sortable>
        <template v-slot="scope">
          <span>￥{{ scope.row.amountIn }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="partBrand" label="品牌" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="partFactory" label="产地" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column
        prop="categoryName"
        label="商品分类"
        width="150"
        show-overflow-tooltip
        sortable
      ></el-table-column>
      <el-table-column prop="vehModel" label="车型" width="250" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="property" label="商品性质" width="110" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="quality" label="品质" width="180"></el-table-column>
      <el-table-column prop="model" label="规格" width="180"></el-table-column>
      <el-table-column
        prop="productionCode"
        label="生产码"
        width="120"
        show-overflow-tooltip
        sortable
      ></el-table-column>
      <el-table-column
        prop="paymentTypeName"
        label="收付类型"
        width="100"
        show-overflow-tooltip
        sortable
      ></el-table-column>
      <el-table-column prop="invoiceType" label="发票类型" width="110" show-overflow-tooltip sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { receivePayDetailsList, billTypes } from "@/api/reconciliation";
export default {
  name: "GoodsSection",
  props: {
    purchaseId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      searchParams: {
        statementId: 0,
        sourceBillNo: "",
        settleType: "",
        keyword: "",
        sourceBillTypes: [],
        sort: "",
        page: 1,
        pageSize: 999
      },
      totalInfo: {},
      tableData: [],
      billtypeList: []
    };
  },
  watch: {
    purchaseId: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getBillTypes();
  },
  methods: {
    //获取来源类型
    getBillTypes() {
      billTypes().then(res => {
        this.billtypeList = res || [];
      });
    },
    reset() {
      this.searchParams = {
        sourceBillNo: "",
        settleType: "",
        keyword: "",
        sourceBillTypes: [],
        sort: "",
        page: 1,
        pageSize: 999
      };
      this.getList();
    },
    search() {
      this.getList();
    },
    getList() {
      this.searchParams.statementId = this.purchaseId;
      receivePayDetailsList(this.searchParams).then(res => {
        console.log("goodsList", res);
        this.tableData = res.rows || [];
        this.totalInfo = {
          amount: res.sumCurr,
          amountOut: res.sumPayCurr,
          amountIn: res.sumReceVCurr
        };
      });
    },
    // 自定义合计方法
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 只对数值类型的列进行合计
        const sumFields = ["amount", "amountOut", "amountIn"];
        if (sumFields.includes(prop)) {
          sums[index] = `￥${this.totalInfo[prop]}`;
        } else {
          sums[index] = "";
        }
      });
      return sums;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .toolbar {
  .el-input-group__append {
    padding: 0;
  }
  .parts-search-append {
    display: flex;
    .parts-search-icon,
    .parts-search-setting {
      padding: 0 10px;
      cursor: pointer;
      font-size: 18px;
    }
    .parts-search-setting {
      border-left: 1px solid #dcdfe6;
    }
  }
}
.section {
  margin-bottom: 30px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 24px;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333333;
}
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  background: rgb(249, 249, 249);
  padding: 12px 16px;
}
.toolbar .el-input,
.toolbar .el-select {
  width: 160px;
}
</style>
